import { memo } from "react"
import { ImExit } from "react-icons/im";
import { IoSettingsSharp } from "react-icons/io5";
import { MdMusicNote, MdMusicOff } from "react-icons/md";

const TableHeader = ((props) => {
    return (
        <div className="truco-table-profile-header">
            <h2 className="truco-game-title">TRUCO</h2>
            
            {/* {props.isMute ? <MdMusicOff className="header-icon-btn" onClick={props.muteTheme} /> : <MdMusicNote className="header-icon-btn" onClick={props.muteTheme} />} */}

            {/* <IoSettingsSharp className="header-icon-btn" onClick={props.onSettingsOpen} /> */}
            <ImExit className="header-icon-btn leave-table-btn" onClick={props.leaveTableHandler} />
        </div>
    )
})

export default memo(TableHeader)